module.exports = __webpack_public_path__ + "img/nfc_on.ba468804.svg";